import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tag } from 'Components';
import { IS_PREVIEW_MODE, TAG_STYLE_ENUMS } from 'Constants';
import style from './RelevantLinks.module.scss';

/**
 * RelevantLinks.jsx
 *
 * @summary Render as Relevant Links list of Annual report cover and content page
 *
 * @param {Object} props - Component props.
 * @prop {Array<Object>} props.linkList - Array of link objects that holds all the data to render link cards it will be used to render the component instead of the individual entity, corporate plan and portfolio props.
 */
function RelevantLinks({ linkList }) {
  const sortedLinkList = linkList.sort((a, b) => a.DisplayOrder - b.DisplayOrder); // Sort the links based on DisplayOrder

  // assuming all links are open within the same tab as design does not have open in new tab icon with it
  const convertTagToHtml = (tag) => {
    return <Tag key={tag.Key} displayText={tag.DisplayText} fullText={tag.FullText} type={tag.Key.includes("tag") ? TAG_STYLE_ENUMS.HIGHLIGHT : TAG_STYLE_ENUMS.GREY} />; // TODO - confirm the type setting is acceptable with Alex
  };
  
  const cardLink = (linkContent, newTab = false) => {
    const linkClass = ['card', style.relevantLink];

    if (!linkContent.Url || !linkContent.LinkTitle) {
      linkClass.push('noContentOutlineOutside'); // Red box style to notify missing content

      if (!IS_PREVIEW_MODE) {
        return <></>; // if published app, return nothing
      }
    }

    return (
      <li key={`relevant-link-${linkContent.DisplayOrder}`}>
        <Link className={linkClass.join(' ')} to={linkContent.Url} target={newTab ? '_blank' : null}>
          <span className={style.tags}>{linkContent.Tags.map((tag) => convertTagToHtml(tag))}</span>
          <span className={style.linkName}>{linkContent.LinkTitle}</span>
          <span className={style.extraText}>{linkContent.ExtraText}</span>
        </Link>
      </li>
    );
  };

  return (
    <div id={style.RelevantLinks} className="fullColorBackground">
      <h2 className="h6">Relevant links</h2>
      <ul>
        {sortedLinkList.map((linkContent) => cardLink(linkContent))}
      </ul>
    </div>
  );
}

const tagPropObjectShape = {
  DisplayText: PropTypes.string.isRequired,
  Key: PropTypes.string.isRequired,
  FullText: PropTypes.string,
  Id: PropTypes.string.isRequired
};

const linkPropObjectShape = {
  LinkTitle: PropTypes.string,
  ExtraText: PropTypes.string, 
  Target: PropTypes.string,
  Url: PropTypes.string,
  Tags: PropTypes.arrayOf(PropTypes.shape(tagPropObjectShape)),
  DisplayOrder: PropTypes.number.isRequired,
  Key: PropTypes.string.isRequired,
};

RelevantLinks.propTypes = {
  linkList: PropTypes.arrayOf(PropTypes.shape(linkPropObjectShape)).isRequired,
};

export default RelevantLinks;
